<template>
  <span></span>
</template>

<script>
export default {
  name: "vc-share-auto-redirecter",
  props: {
    url: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.url) {
      location.href = this.url;
    }
  },
  data: () => {
    return {};
  }
};
</script>

<style></style>
